import { render, staticRenderFns } from "./rate-plan-modal.vue?vue&type=template&id=6dcc52bb&"
import script from "./rate-plan-modal.vue?vue&type=script&lang=js&"
export * from "./rate-plan-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports